var btnChevron = {
  "btnChevron": {
    "background": "#f7f8f9",
    "borderColor": "#c8c9c7",
    "color": "#000",
    "&:hover": {
      "background": "#e8ebee"
    },
    "&:active": {
      "background": "#dadfe3"
    },
    "paddingLeft": "0.625rem",
    "textAlign": "left",
    "&::after": {
      "fontFamily": "\"dls-icons-2.25.0\"",
      "content": "\"\"",
      "lineHeight": "1",
      "WebkitFontSmoothing": "antialiased",
      "MozOsxFontSmoothing": "grayscale",
      "color": "#53565a",
      "fontSize": "1rem",
      "marginRight": "0.375rem",
      "marginTop": "-0.5rem",
      "position": "absolute",
      "right": "0",
      "top": "50%",
      "transition": "color 0.25S ease-out"
    }
  }
};

export default btnChevron;
